import React, { useState } from "react";
import { postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import { Input } from "antd";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";

const AddNewDynamicForm = ({ onOpen, onClose, clientId, showPopup }) => {
  const [title, setTitle] = useState("");
  const { TextArea } = Input;
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAcceptDialog, setShowAcceptDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    title: "",
    description: "",
  });

  const handleSave = async () => {
    setLoading(true);
    try {
      const response = await postApi({
        apiUrl: API_URLS.CREATE_CUSTOMER_DYNAMIC_FORM,
        data: {
          title,
          description,
        },
        headers: { client: clientId },
      });

      if (response.success) {
        showPopup("success", "Success", "Dynamic Form Added Successfully");
        onClose();
      } else {
        showPopup(
          "error",
          "Error",
          response.message || "Failed to create form."
        );
      }
    } catch (error) {
      console.error(error.response?.data?.message || "Something went wrong.");
      showPopup(
        "error",
        "Error",
        error.response?.data?.message || "Something went wrong."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setErrorMessage({});
    onClose();
  };

  return (
    <>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">Add New </h3>
        </div>
        <div className="rounded-xl border mt-8 px-12 pt-5">
          <div className="flex flex-col gap-6">
            <Input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Title"
              className="h-14 rounded-lg"
            />
            {errorMessage.title && (
              <div className="text-red-500 text-sm">{errorMessage.title}</div>
            )}

            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-700">
                Description
              </label>
              <TextArea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter description..."
                className="rounded-lg"
                autoSize={{ minRows: 4, maxRows: 6 }}
              />
              {errorMessage.description && (
                <div className="text-red-500 text-sm">
                  {errorMessage.description}
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Cancel"
              onClick={handleCancel}
              className="text-base font-normal h-[50px] w-[160px]"
            />

            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Save"
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
            />
          </div>
        </div>
      </DailogBox>
      {/* {showAcceptDialog && (
        <AcceptDialog
          open={showAcceptDialog}
          close={() => {
            setShowAcceptDialog(false);
            onClose();
          }}
          heading="Success!"
          subheading="Dynamics  Survey Forms add Successfully "
          success={true}
        />
      )} */}
    </>
  );
};

export default AddNewDynamicForm;
